import { useEffect, useLayoutEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useScrollPositionContext } from 'src/components/ScrollPositionProvider/ScrollPositionContext';
import { isModalUrl } from 'src/utils/ModalRoute';
import { getLocationFragment, scrollToAnchor, scrollToPosition, scrollToTop } from 'src/utils/ScrollUtils';

export function useScrollOnRender() {
  const { action, location } = useHistory();
  const { scrollPositionToRestore } = useScrollPositionContext();
  const [previousPathname, setPreviousPathname] = useState('');

  useEffect(() => {
    setPreviousPathname(location.pathname);
  }, [location]);

  useLayoutEffect(() => {
    const hash = getLocationFragment(location.hash);

    const shouldScrollToAnchor = !!hash;
    const shouldScrollToTop = !isModalUrl(location.pathname) && !isModalUrl(previousPathname);
    const shouldRestorePosition = () => {
      if (action === 'POP') {
        if (hash) {
          return (location.pathname !== previousPathname);
        }
        return true;
      }
      return false;
    };

    if (shouldRestorePosition()) {
      scrollToPosition(scrollPositionToRestore.current);
      return;
    }

    if (shouldScrollToAnchor) {
      const element = document.getElementById(hash);
      scrollToAnchor(element);
      return;
    }

    if (shouldScrollToTop) {
      scrollToTop();
    }
  }, [location]);
}
